import { createBrowserRouter, RouterProvider, useParams } from "react-router-dom";
import { Layout } from "./components/Layout";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { DiagnosticPage } from "./pages/DiagnosticPage";
import { ExamPage } from "./pages/ExamPage";
import { GlossaryPage } from "./pages/GlossaryPage";
import { GuidePage } from "./pages/GuidePage";
import { ResourcesPage } from "./pages/ResourcesPage";
import { FeedbackPage } from "./pages/FeedbackPage";
import { LoginPage } from "./pages/LoginPage";
import { PrivacyPage } from "./pages/PrivacyPage";
import { RequireAdmin, RequireAuth } from "./components/Auth";
import { useSession } from "./lib/session";
import { ExamsPage } from "./pages/ExamsPage";
import { FlashcardsPage } from "./pages/FlashcardsPage";
import { HomePage } from "./pages/HomePage";
import { LabPage } from "./pages/LabPage";
import { LabsPage } from "./pages/LabsPage";
import { LearnPage } from "./pages/LearnPage";
import { LessonPage } from "./pages/LessonPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { ProgressPage } from "./pages/ProgressPage";
import { ResultPage } from "./pages/ResultPage";
import { ReviewPage } from "./pages/ReviewPage";
import { SessionPage } from "./pages/SessionPage";
import { AdminPage } from "./pages/AdminPage";
import { ClaudeCodePage } from "./pages/ClaudeCodePage";

/** Khách làm được bài kiểm tra trình độ (dùng bộ câu công khai); phiên khác cần đăng nhập. */
function SessionGate() {
  const s = useSession();
  return <RequireAuth allow={s?.kind === "diagnostic" || !!s?.trial}><SessionPage /></RequireAuth>;
}

/** Remount khi đổi tham số để reset state cục bộ của trang. */
function Keyed({ param, children }: { param: string; children: (key: string) => React.ReactNode }) {
  const params = useParams();
  return <>{children(params[param] ?? "")}</>;
}

export const routes = [
  {
    path: "/",
    element: <Layout />,
    errorElement: <ErrorBoundary />,
    children: [
      { index: true, element: <HomePage /> },
      { path: "learn", element: <LearnPage /> },
      { path: "learn/:lessonId", element: <Keyed param="lessonId">{(k) => <LessonPage key={k} />}</Keyed> },
      { path: "exams", element: <ExamsPage /> },
      { path: "exams/:examId", element: <Keyed param="examId">{(k) => <ExamPage key={k} />}</Keyed> },
      { path: "labs", element: <RequireAuth><LabsPage /></RequireAuth> },
      { path: "labs/:labId", element: <RequireAuth><Keyed param="labId">{(k) => <LabPage key={k} />}</Keyed></RequireAuth> },
      { path: "session", element: <SessionGate /> },
      { path: "result/:attemptId", element: <ResultPage /> },
      { path: "review", element: <RequireAuth><ReviewPage /></RequireAuth> },
      { path: "flashcards", element: <RequireAuth><FlashcardsPage /></RequireAuth> },
      { path: "progress", element: <RequireAuth><ProgressPage /></RequireAuth> },
      { path: "login", element: <LoginPage /> },
      { path: "privacy", element: <PrivacyPage /> },
      { path: "diagnostic", element: <DiagnosticPage /> },
      { path: "guide", element: <GuidePage /> },
      { path: "glossary", element: <GlossaryPage /> },
      { path: "resources", element: <ResourcesPage /> },
      { path: "claude-code", element: <ClaudeCodePage /> },
      { path: "feedback", element: <FeedbackPage /> },
      { path: "admin", element: <RequireAdmin><AdminPage /></RequireAdmin> },
      { path: "*", element: <NotFoundPage /> },
    ],
  },
];

const router = createBrowserRouter(routes);

export function App() {
  return <RouterProvider router={router} />;
}
